export default __webpack_public_path__ + "static/media/NSVT03.3043682d.png";